export const SHOPIFY_CHECKOUT_ID = 'shopify_checkout_id'
export const SHOPIFY_CART_ID = 'shopify_cart_id'

export const SUBSCRIPTION_FREQUENCIES = ['90', '45', '30', '21']
export const SUBSCRIPTION_SIZES = ['MINI', 'SMALL', 'MEDIUM', 'LARGE']
